import { render, staticRenderFns } from "./category.vue?vue&type=template&id=a774f4ce&scoped=true"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"
import style0 from "./category.vue?vue&type=style&index=0&id=a774f4ce&prod&scoped=true&lang=css"
import style1 from "./category.vue?vue&type=style&index=1&id=a774f4ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a774f4ce",
  null
  
)

export default component.exports